module.exports = __webpack_public_path__ + "img/foundry-spatial-logo-with-text.90760d18.svg";